import { createContext } from "react";
import { CenteredNavContextType } from "./types";

export const CenteredNavContext = createContext<CenteredNavContextType>({
	activeTabI: 0,
	setActiveTabI: () => {},
});
